<template>
  <div
    v-if="list.length > 0"
    class="key_list"
  >
    <div class="key_list_tit">
      <h3>搜索历史</h3>
      <a
        class="tit_r"
        @click="clear"
      >
        <i class="icon_trash" />
      </a>
    </div>
    <ul>
      <li
        v-for="(key, index) in list"
        :key="index"
      >
        <a :href="key | toSearchUrl(spver)">{{ key }}</a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  filters: {
    toSearchUrl(key, spver) {
      let url = `/v?query=${encodeURIComponent(key)}&ie=utf8`;
      if (spver === 1) {
        url += '&spver=1';
      }
      return url;
    },
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      spver: +this.$route.query.spver === 1 ? 1 : '',
      list: [],
      name: 'v_search_record',
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      const { name } = this;
      if (window.localStorage && window.localStorage.getItem(name) && window.localStorage.getItem(name).length > 0) {
        let searchRecords = window.localStorage.getItem(name);
        if (searchRecords && searchRecords.length > 0) {
          searchRecords = JSON.parse(searchRecords);
          for (let i = 0; i < searchRecords.length; i += 1) {
            const key = searchRecords[i].replace(/(^\s*)|(\s*$)/g, '');
            if (key) {
              this.list.push(key);
            }
          }
        }
      }
    },
    clear() {
      if (confirm('清除全部历史查询记录？')) {
        if (window.localStorage) {
          window.localStorage.removeItem(this.name);
        }
        this.list = [];
      }
    },
  },
};
</script>

<style lang="scss">
@import '../../../asset/css/abstracts/mixin.scss';
@import '../../../asset/css/abstracts/function_sprite_hotsugg.scss';

.key_list {
  position: relative;
  color: #555;
  padding: 0 16px;

  .key_list_tit {
    overflow: hidden;
    padding: 6px 0 15px;

    > h3 {
      display: inline-block;
      font-size: 14px;
      font-weight: bold;
      color: #000;

      > span {
        color: #aaa;
        font-size: 12px;
      }
    }

    > .tit_r {
      float: right;
      font-size: 15px;
      font-weight: bold;

      > .icon_trash {
        @include sprite-item('hotsugg/trash');
        display: inline-block;
        margin-left: 3px;
      }
    }
  }

  > ul {
    overflow: hidden;
    max-height: 121px;
    margin-bottom: 15px;
    > li {
      overflow: hidden;
      float: left;
      height: 35px;
      border-radius: 3px;
      background: #f5f5f5;
      margin: 0 8px 8px 0;
      line-height: 35px;
      font-size: 13px;
      color: #222;

      > a {
        padding: 0 12px;
        color: #222;
      }
    }
  }
}
</style>
